(ns app.front.view.group.admin.fees.schedule.template-variable-editor
  (:require [app.domain.fee.model :as fee-model]
            [app.front.ui :as ui]
            [app.front.ui.content-switcher :as ui-cs]
            [app.front.ui.error-boundary :as eb]
            [app.front.view.group.admin.fees.template.template-core :as ft-core]
            [app.front.view.group.admin.fees.template.template-events :as ft-events]
            [app.front.view.group.admin.fees.template.template-subs :as ft-subs]
            [app.front.view.group.admin.fees.variable.variable-core :as fv-core]
            [app.front.view.group.admin.fees.variable.variable-subs :as fv-subs]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-sub ::unsaved-changes
  :<- [::ft-subs/unsaved-changes]
  :<- [::fv-subs/unsaved-changes]
  (fn [[unsaved-template-changes unsaved-variable-changes] _]
    (or (some? unsaved-template-changes)
        (some? unsaved-variable-changes))))


(defn view [{:keys [tr]}]
  (r/with-let [*current-view        (r/atom :templates)
               on-template-selected (fn [fee-template]
                                      (>evt [::ft-events/select-fee-template (:db/id fee-template)])
                                      (reset! *current-view :templates))]
    (let [lang             (<sub [:language])
          fee-schedule     (<sub [::ft-subs/fee-schedule])
          disabled?        (<sub [::ft-subs/editor-disabled?])
          close-event      (<sub [::ft-subs/close-callback-event])
          unsaved-changes? (<sub [::unsaved-changes])]
      [:div.fixed.overflow-auto.z-20.w-full.h-full.py-32.top-0.left-0
       [:div.bx--grid.max
        [:div.p-8.bg-white.shadow-lg
         [:header.mb-4.flex.justify-between.items-start
          [:h1.pr-4.text-lg.leading-7
           [:span (if disabled?
                    (tr [:fees/view-fee-templates])
                    (tr [:fees/configure-fee-templates]))]
           " "
           [:span.font-bold (fee-model/fee-schedule-title fee-schedule lang)]]
          [eb/error-boundary
           [ui/modal-confirmation-button
            {:skip-confirm?       (not unsaved-changes?)
             :tr                  tr
             :on-yes-click        #(>evt close-event)
             :trigger-button-text (tr [:close])
             :trigger-button-opts {:kind :tertiary}}
            (tr [:fees/confirm-exit-fee-template-editing])]]]
         [:div
          [ui-cs/content-switcher
           {:items     [:templates :variables]
            :on-change #(reset! *current-view %)
            :current   @*current-view
            :val->str  #(tr [(case % :templates :fees/fee-templates :fees/fee-variables)])
            :class     "mb-4"}]]
         (case @*current-view
           :templates [ft-core/view (util/mmap tr)]
           :variables [fv-core/view (util/mmap tr on-template-selected fee-schedule)])]]])))
